import CtaBox from './ctaBox';

export default CtaBox;
